import type {
  InsolvencyCheckerOutput,
  Task,
} from "@gearbox-protocol/deploy-tools-shared";
import { api } from "api";
import { useAsync } from "react-use";

export default function useInsolvencyReport(task: Task) {
  return useAsync(async () => {
    const result = await api.fetchTaskArtifact<InsolvencyCheckerOutput>(
      task,
      "output.json",
    );
    result.pools = result.pools.sort((a, b) => {
      const aIsBad = !a.isSuccessful || a.expectedLiquidity > a.realLiquidity;
      const bIsBad = !b.isSuccessful || b.expectedLiquidity > b.realLiquidity;
      if (aIsBad !== bIsBad) {
        return aIsBad ? -1 : 1;
      }
      return 0;
    });

    return result;
  }, [task]);
}
